
import React from "react";
import { Button } from "@/components/ui/button";
import { useUserProfile } from "@/hooks/useUserProfile";
import AvatarUploadSection from "@/components/profile/AvatarUploadSection";
import PersonalInfoSection from "@/components/profile/PersonalInfoSection";
import { User } from "lucide-react";

const UserProfile = () => {
  const { profile, loading, saveLoading, updateProfile, handleInputChange, fetchProfile } = useUserProfile();

  const handleSavePersonalInfo = () => {
    if (!profile) return;
    updateProfile({
      full_name: profile.full_name,
      email: profile.email,
      phone: profile.phone
    });
  };

  const handleAvatarUpdate = (avatarUrl: string) => {
    handleInputChange('avatar_url', avatarUrl);
  };

  if (loading) return <div className="text-center py-10">جار التحميل...</div>;

  if (!profile) {
    return (
      <div className="text-center py-10 text-gray-600">
        <User className="h-16 w-16 mx-auto text-gray-400 mb-4" />
        <h3 className="text-lg font-semibold mb-2">خطأ في تحميل البيانات</h3>
        <Button onClick={fetchProfile}>إعادة المحاولة</Button>
      </div>
    );
  }

  return (
    <div className="space-y-6" dir="rtl">
      <AvatarUploadSection
        profile={profile}
        onAvatarUpdate={handleAvatarUpdate}
      />

      <PersonalInfoSection
        profile={profile}
        onInputChange={handleInputChange}
        onSave={handleSavePersonalInfo}
        saveLoading={saveLoading}
      />
    </div>
  );
};

export default UserProfile;
